/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

//* import css
import cssClasses from './LiveInventory.module.css';

//* imports MUI
import { Box } from '@mui/material';
import {
  getAllUnitsByWings,
} from '../../../Services/LiveInventory';
import { useParams } from 'react-router-dom';
import {
  getLaunches,
  getProjectDataByProjectId,
} from '../../../Services/FastBooking';
import { chain, sortBy, uniqBy } from 'lodash';
import { getEvent, getLaunchDetails } from '../../../Services/Event';
import { supabase } from '../../../supabaseClient';
import EmptyListIcon from '../../../Assets/Images/Common/EmptyListLeads.svg';
import { errorTost, offlineToast } from '../../../Services/Toast';
import { Network } from '@capacitor/network';

function LiveInventory() {
  const { eventId, launchId, wingId, projectId } = useParams();
  const [allLaunches, setAllLaunches] = useState([]);
  const [selectedLaunch, setSelectedLaunch] = useState('');
  const [wingWiseGroups, setWingWiseGroups] = useState([]);
  const [unitTypeDisplay, setUnitTypeDisplay] = useState([]);
  const [eventTitle, setEventTitle] = useState('');
  const [projectTitle, setProjectTitle] = useState('');
  const [showInventory, setShowInventory] = useState(null);
  const [type, setType] = useState('');
  const [unitTypeColorArr, setUnitTypeColorArr] = useState(null);
  useEffect(() => {
    let type = JSON.parse(sessionStorage.getItem('selectedType'));
    setType(type);
    if (type === 'Event') {
      Network.getStatus().then((status) => {
        if (status.connected) {
          fetchLaunchDisplay()
        } else {
          offlineToast();
        }
      });
    } else {
      Network.getStatus().then((status) => {
        if (status.connected) {
          fetchProjectDisplay()

        } else {
          offlineToast();
        }
      })
    }
  }, []);

  const [retryCounts, setRetryCounts] = useState({
    inventory: 0,
    project: 0,
    inventoryColor: 0,
  });

  const [inventoryTypeWise, setInventoryTypeWise] = useState(null);

  const MAX_RETRIES = 5;
  let updateUnitListener;
  let updateProjectListener;
  let getInventoryColorListener;
  // ??SnapShot call
  useEffect(() => {
    const subscribeToInventory = () => {
      updateUnitListener = supabase
        .from(`Inventory:projectId=eq.${projectId}`)
        .on('UPDATE', (handleRecordUpdated) => {
          if (JSON.parse(sessionStorage.getItem('selectedType')) === 'Event') {
            fetchLaunchDisplay()
          } else {
            fetchProjectDisplay()
          }
        })
        .subscribe((status) => {
          console.log('status: ', status);
          if (status === 'CLOSED' || status === 'SUBSCRIPTION_ERROR') {
            console.log('Subscription closed or error, attempting to reconnect...');
            setRetryCounts((prev) => {
              if (prev.inventory < MAX_RETRIES) {
                setTimeout(() => {
                  subscribeToInventory();
                }, 5000);
                return { ...prev, inventory: prev.inventory + 1 };
              } else {
                errorTost("Auto-refresh failed! Please try again later.");
                window.location.reload(); // Reload the page after max retries
                return prev; // Return previous state without updating
              }
            });
          }
        });
    }

    const subscribeToProject = () => {
      updateProjectListener = supabase
        .from(`Projects:projectId=eq.${projectId}`)
        .on('UPDATE', (handleRecordUpdated) => {
          if (JSON.parse(sessionStorage.getItem('selectedType')) === 'Event') {
            fetchLaunchDisplay()
          } else {
            fetchProjectDisplay()
          }
        })
        .subscribe((status) => {
          console.log('status: ', status);
          if (status === 'CLOSED' || status === 'SUBSCRIPTION_ERROR') {
            console.log('Subscription closed or error, attempting to reconnect...');
            setRetryCounts((prev) => {
              if (prev.project < MAX_RETRIES) {
                setTimeout(() => {
                  subscribeToProject();
                }, 5000);
                return { ...prev, project: prev.project + 1 };
              } else {
                errorTost("Auto-refresh failed! Please try again later.");
                window.location.reload(); // Reload the page after max retries
                return prev; // Return previous state without updating
              }
            });
          }
        });
    }
    const subscribeToInventoryColor = () => {
      const launchIds = JSON.parse(sessionStorage.getItem('selectedLaunches'));
      let whereClause = launchId === "All" ? launchIds : [launchId];
      getInventoryColorListener = supabase
        .from(`Launches`)
        .on('UPDATE', (handleRecordUpdated) => {
          if (whereClause.includes(handleRecordUpdated.new.launchId)) {
            Network.getStatus().then((status) => {
              if (status.connected) {
                getEvent(eventId)
                  .then((resp) => {
                    setEventTitle(resp[0].title);
                    getAllLaunches(
                      eventId,
                    );
                    getLaunchDetails(launchId).then((launchResp) => {
                      let arr = [];
                      launchResp.forEach((each) => {
                        if (each?.unitTypeDisplay) {
                          arr = [...arr, each?.unitTypeDisplay]
                          setUnitTypeDisplay(prev => [...prev, each?.unitTypeDisplay])
                        }
                      })
                      const combineArray = arr.reduce((acc, val) => acc.concat(val), []);
                      sessionStorage.setItem(
                        'liveInventoryUnitTypeDisplay',
                        JSON.stringify(combineArray)
                      );

                    }).catch((err) => {
                      errorTost(err.message)
                    })
                  })
                  .catch((err) => {
                    errorTost(err.message)
                  });
              }
            });
          }

        })
        .subscribe((status) => {
          console.log('status: ', status);
          if (status === 'CLOSED' || status === 'SUBSCRIPTION_ERROR') {
            console.log('Subscription closed or error, attempting to reconnect...');
            setRetryCounts((prev) => {
              if (prev.inventoryColor < MAX_RETRIES) {
                setTimeout(() => {
                  subscribeToInventoryColor();
                }, 5000);
                return { ...prev, inventoryColor: prev.inventoryColor + 1 };
              } else {
                errorTost("Auto-refresh failed! Please try again later.");
                window.location.reload(); // Reload the page after max retries
                return prev; // Return previous state without updating
              }
            });
          }
        });
    }

    subscribeToInventory();
    subscribeToProject();
    subscribeToInventoryColor();
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
      if (updateProjectListener) {
        supabase.removeSubscription(updateProjectListener);
        updateProjectListener = null;
      }

      if (getInventoryColorListener) {
        supabase.removeSubscription(getInventoryColorListener);
        getInventoryColorListener = null;
      }
    };
  }, [projectId]);

  function fetchLaunchDisplay() {
    getEvent(eventId)
      .then((resp) => {
        setEventTitle(resp[0].title);
        getAllLaunches(
          eventId,
        );
        getLaunchDetails(launchId).then((launchResp) => {
          let arr = [];
          launchResp.forEach((each) => {
            if (each?.unitTypeDisplay) {
              arr = [...arr, each?.unitTypeDisplay]
              setUnitTypeDisplay(prev => [...prev, each?.unitTypeDisplay])
            }
          })
          const combineArray = arr.reduce((acc, val) => acc.concat(val), []);
          sessionStorage.setItem(
            'liveInventoryUnitTypeDisplay',
            JSON.stringify(combineArray)
          );
        }).catch((err) => {
          errorTost(err.message)
        })
      })
      .catch((err) => {
        errorTost(err.message)
      });
  }

  function fetchProjectDisplay() {
    getProjectDataByProjectId(projectId)
      .then((resp) => {
        setProjectTitle(resp.data[0].projectName);
        setUnitTypeDisplay(resp.data[0].unitTypeDisplay)
        sessionStorage.setItem(
          'liveInventoryUnitTypeDisplay',
          JSON.stringify(resp.data[0].unitTypeDisplay)
        );
        getAllInventory()
      })
      .catch((err) => {
        errorTost(err.message)
      });
  }


  function getAllLaunches(eventId) {
    getLaunches(eventId)
      .then((resp) => {
        resp.data = resp.data.map((each) => ({
          ...each,
          label: each.title,
          value: each.launchId,
        }));
        setAllLaunches([...resp.data]);
        sessionStorage.setItem(
          'liveInventoryLaunchId',
          JSON.stringify(resp.data[0].launchId)
        );
        sessionStorage.setItem(
          'liveInventoryProjectId',
          JSON.stringify(resp.data[0].projectId.projectId)
        );
        setSelectedLaunch(resp.data[0].launchId);
        getAllInventory(
          resp.data[0].launchId
        );
      })
      .catch((err) => {
        errorTost(err.message)
      });
  }
  function getAllInventory() {
    getAllUnitsByWings(launchId, wingId, projectId).then((resp) => {
      const sessionUnitTypeArr =
        JSON.parse(sessionStorage.getItem('liveInventoryUnitTypeDisplay')) ??
        [];
      resp.data.forEach((el) => {
        el.show = false;
        let unitTypeFilter = sessionUnitTypeArr.find((elem, i) => {
          return elem.unitType === el.unitId.inventoryTypeId.type;
        });
        if (unitTypeFilter) {
          if (unitTypeFilter.display) {
            let unitStatusFilter = unitTypeFilter?.unitStatusDisplay.find(
              (elm, i) => {
                return elm.unitStatus === el.unitId.inventoryStatusId.status;
              }
            );
            if (unitStatusFilter?.display) {
              el.color = unitStatusFilter.color;
              el.textColor = unitStatusFilter.textColor;
              el.show = true;
            }
          }
        }
      });

      let obj = {};
      sessionUnitTypeArr.forEach((unittype) => {
        if (unittype.display) {
          obj[unittype.unitType] = {
            color: '',
            textColor: '',
          };
          let availableColor = unittype.unitStatusDisplay.find((status) => {
            return status.unitStatus === 'Available';
          });
          if (availableColor && availableColor.display) {
            obj[unittype.unitType].color = availableColor.color;
            obj[unittype.unitType].textColor = availableColor.textColor;
          }
        }
      });
      setUnitTypeColorArr(obj);
      let respArr = [];
      resp.data.forEach((each) => {
        if (each.show) {
          const obj = {
            ...each,
            wingName: each.wingId.wingName,
            floorNo: each.unitId.floorNo,
            unitNo: each.unitId.unitNo,
            inventoryStatus: each.unitId.inventoryStatusId.status,
            inventoryType: each.unitId.inventoryTypeId.type,
          };
          respArr.push(obj);
        }
      });

      sortBy(respArr, 'floorNo', '');
      // sortBy(resp.data, "floorNo");
      // ??Filters for showing statuswise or inventory type
      // !!Removed filter for color according to status like available,hold etc
      // resp.data = resp.data.filter(
      //   ({ colorAccordingToStatus }) => colorAccordingToStatus !== ""
      // );
      // resp.data = resp.data.filter(
      //   ({ colorAccordingToInventoryType }) =>
      //     colorAccordingToInventoryType !== ""
      // );
      // console.log("resp.data", resp.data)

      // ??wing wise grouping

      let allWingWiseGrouping = chain(respArr)
        .groupBy('wingId.wingId')
        // .groupBy('wingId.displayName')
        .map((value, key) => (
          { Wing: key, Units: value, wingName: value[0].wingId.displayName ? value[0].wingId.displayName : value[0].wingName }
        ))
        // .map((value, key) => (
        //   { Wing: key, Units: value  , displayName : respArr[0].wingId.displayName}
        //   ))
        .value();

      allWingWiseGrouping.forEach((el) => {
        let allFloorWiseGrouping = chain(el.Units)
          .groupBy('floorNo')
          .map((value, key) => ({ Floor: key, Units: value, displayName: el.Units[0].wingId.displayName }))
          .value();
        el.Units.floorWise = allFloorWiseGrouping;
      });
      allWingWiseGrouping.forEach((el) => {
        el.Units.floorWise = addMissingUnits(el.Units.floorWise)
      });
      let typeWiseArray = [];
      allWingWiseGrouping.forEach((el) => {
        typeWiseArray.push({ wingName: el.wingName, type: getMaxInventoryTypeByLastTwoDigits(el.Units.floorWise) })
      });
      setWingWiseGroups([...allWingWiseGrouping]);
      setInventoryTypeWise(typeWiseArray)

      if (allWingWiseGrouping.length === 0) {
        setShowInventory(false);
      } else {
        setShowInventory(true);
      }
    }).catch((err) => {
      console.error(err)
      errorTost(err.message)
    });
  }

  const addMissingUnits = (floorData) => {
    // Step 1: Find the highest unit for each floor and prefix (if present) based on the last two digits
    const highestUnitsByPrefix = floorData.map(floor => {
      const prefixes = {};

      floor.Units.forEach(unit => {
        if (unit.unitNo.includes('-')) {
          const [prefix, number] = unit.unitNo.split('-'); // Split the unitNo into prefix and number
          const unitNumber = parseInt(number, 10);

          // Track the highest unit for each prefix
          if (!prefixes[prefix]) {
            prefixes[prefix] = { highestUnit: unitNumber };
          } else {
            prefixes[prefix].highestUnit = Math.max(prefixes[prefix].highestUnit, unitNumber);
          }
        } else {
          const unitNumber = parseInt(unit.unitNo, 10);

          // Track the highest unit without prefix
          if (!prefixes["noPrefix"]) {
            prefixes["noPrefix"] = { highestUnit: unitNumber };
          } else {
            prefixes["noPrefix"].highestUnit = Math.max(prefixes["noPrefix"].highestUnit, unitNumber);
          }
        }
      });

      return {
        floor: floor.Floor,
        prefixes
      };
    });

    // Step 2: Determine the maximum last two digits for each prefix (or no prefix) across all floors
    const maxLastTwoDigitsByPrefix = {};

    highestUnitsByPrefix.forEach(floor => {
      Object.keys(floor.prefixes).forEach(prefix => {
        const lastTwoDigits = floor.prefixes[prefix].highestUnit % 100;
        if (!maxLastTwoDigitsByPrefix[prefix]) {
          maxLastTwoDigitsByPrefix[prefix] = lastTwoDigits;
        } else {
          maxLastTwoDigitsByPrefix[prefix] = Math.max(maxLastTwoDigitsByPrefix[prefix], lastTwoDigits);
        }
      });
    });

    // Step 3: Update each floor with the missing units for each prefix (or no prefix)
    return floorData.map(floor => {
      const newUnits = [...floor.Units];

      // Handle both prefixed and non-prefixed units
      Object.keys(maxLastTwoDigitsByPrefix).forEach(prefix => {
        const existingUnits = floor.Units
          .filter(unit => prefix === "noPrefix" ? !unit.unitNo.includes('-') : unit.unitNo.startsWith(prefix)) // Handle prefix or no prefix
          .map(unit => prefix === "noPrefix" ? parseInt(unit.unitNo, 10) : parseInt(unit.unitNo.split('-')[1], 10)); // Extract the numeric part

        const wingName = floor.Units[0].wingName; // Assuming wingName is the same for all units on the floor

        // Calculate the starting and ending unit number based on the floor number
      const floorNumber = parseInt(floor.Floor.split(" ")[1], 10);
      const startUnit = floorNumber * 100 + 1; // Starting unit number for the floor
        const endUnit = floorNumber * 100 + maxLastTwoDigitsByPrefix[prefix]; // End unit using max last two digits

        // Generate the expected unit range for this prefix or no prefix
      const expectedUnits = Array.from({ length: endUnit - startUnit + 1 }, (_, i) => startUnit + i);
        // Step 4: Determine missing units for the current prefix or no prefix on this floor
        const missingUnits = expectedUnits.filter(unitNumber =>
          !existingUnits.includes(unitNumber)
        );

        // Create unit objects for missing units with or without the prefix
        const missingUnitObjects = missingUnits.map(unitNumber => ({
        floorNo: floor.Floor,
          unitNo: prefix === "noPrefix" ? `${unitNumber}` : `${prefix}-${unitNumber}`, // Add prefix if it exists, otherwise just the number
        inventoryType: "",
        wingName: wingName
      }));

        // Add missing units to the existing units for this prefix or no prefix
        newUnits.push(...missingUnitObjects);
      });

      return {
        ...floor,
        Units: newUnits
      };
    });
  };

  const getMaxInventoryTypeByLastTwoDigits = (floorData) => {
    // Step 1: Create an object to keep track of inventory types based on prefix and last two digits
    const inventoryCountByPrefixAndLastTwoDigits = {};
    const inventoryCountByLastTwoDigits = {};
    // Step 2: Loop through each floor and each unit
    if (floorData[0].Units[0].unitNo.includes('-')) {
      floorData.forEach(floor => {
        floor.Units.forEach(unit => {
          const unitNo = unit.unitNo; // Original unit number
          const lastTwoDigits = unitNo.slice(-2); // Get the last two digits of the unit number

          const prefix = unit.unitNo.split('-')[0]; // Get the prefix excluding last two digits
          const inventoryType = unit?.unitId?.displayUnitType ? unit?.unitId?.displayUnitType : unit.inventoryType || "None"; // Default to "None" if no inventory type
          // Initialize the object for this prefix if it doesn't exist
          if (!inventoryCountByPrefixAndLastTwoDigits[prefix]) {
            inventoryCountByPrefixAndLastTwoDigits[prefix] = {};
          }

          // Initialize the object for this last two digits if it doesn't exist
          if (!inventoryCountByPrefixAndLastTwoDigits[prefix][lastTwoDigits]) {
            inventoryCountByPrefixAndLastTwoDigits[prefix][lastTwoDigits] = {};
          }

          // Increment the count for this inventory type
          if (!inventoryCountByPrefixAndLastTwoDigits[prefix][lastTwoDigits][inventoryType]) {
            inventoryCountByPrefixAndLastTwoDigits[prefix][lastTwoDigits][inventoryType] = 0;
          }
          inventoryCountByPrefixAndLastTwoDigits[prefix][lastTwoDigits][inventoryType]++;
        });
      });

      // Step 3: Construct the result based on the maximum counts for each prefix and last two digits
      let maxInventoryTypes = [];
      for (const prefix in inventoryCountByPrefixAndLastTwoDigits) {
        for (const lastTwoDigits in inventoryCountByPrefixAndLastTwoDigits[prefix]) {
          const types = inventoryCountByPrefixAndLastTwoDigits[prefix][lastTwoDigits];
          const maxType = Object.keys(types).reduce((max, type) => {
            return types[type] > types[max] ? type === "None" ? max : type : max === "None" ? type : max;
          }, Object.keys(types)[0]); // Start with the first type

          maxInventoryTypes.push({
            prefix: prefix,
            lastTwoDigits: lastTwoDigits,
            inventoryType: maxType
          });
        }
      }

      // Sort the results by prefix and last two digits
      maxInventoryTypes.sort((a, b) => {
        if (a.prefix < b.prefix) return -1;
        if (a.prefix > b.prefix) return 1;
        return parseInt(a.lastTwoDigits, 10) - parseInt(b.lastTwoDigits, 10);
      });

      return maxInventoryTypes;
    }
    else {
    floorData.forEach(floor => {
      floor.Units.forEach(unit => {
        const lastTwoDigits = unit.unitNo.slice(-2); // Get the last two digits of the unit number
          const inventoryType = unit?.unitId?.displayUnitType ? unit?.unitId?.displayUnitType : unit.inventoryType || "None"; // Default to "None" if no inventory type

        // Initialize the object for this last two digits if it doesn't exist
        if (!inventoryCountByLastTwoDigits[lastTwoDigits]) {
          inventoryCountByLastTwoDigits[lastTwoDigits] = {};
        }

        // Increment the count for this inventory type
        if (!inventoryCountByLastTwoDigits[lastTwoDigits][inventoryType]) {
          inventoryCountByLastTwoDigits[lastTwoDigits][inventoryType] = 0;
        }
        inventoryCountByLastTwoDigits[lastTwoDigits][inventoryType]++;
      });
    });

      for (const key in inventoryCountByLastTwoDigits) {
        // Normalize the key to two digits
        const normalizedKey = key.padStart(2, '0');

        if (normalizedKey !== key) {
          // If the normalized key exists, merge the counts
          if (inventoryCountByLastTwoDigits[normalizedKey]) {
            // Merge counts for each inventory type
            for (const type in inventoryCountByLastTwoDigits[key]) {
              if (inventoryCountByLastTwoDigits[normalizedKey][type]) {
                inventoryCountByLastTwoDigits[normalizedKey][type] += inventoryCountByLastTwoDigits[key][type];
              } else {
                inventoryCountByLastTwoDigits[normalizedKey][type] = inventoryCountByLastTwoDigits[key][type];
              }
            }
          } else {
            // If not exists, create the normalized key with current data
            inventoryCountByLastTwoDigits[normalizedKey] = { ...inventoryCountByLastTwoDigits[key] };
          }
          // Delete the old key
          delete inventoryCountByLastTwoDigits[key];
        }
      }
    // Step 3: Construct the result based on the maximum counts for each last two digits
    let maxInventoryTypes = Object.keys(inventoryCountByLastTwoDigits).map(lastTwoDigits => {
      const types = inventoryCountByLastTwoDigits[lastTwoDigits];
      const maxType = Object.keys(types).reduce((max, type) => {
        return types[type] > types[max] ? type === "None" ? max : type : max === "None" ? type : max;
      }, Object.keys(types)[0]); // Start with the first type
      return {
        lastTwoDigits: lastTwoDigits,
        inventoryType: maxType
      };
    });
    maxInventoryTypes = maxInventoryTypes.sort((a, b) => parseInt(a.lastTwoDigits, 10) - parseInt(b.lastTwoDigits, 10));
    return maxInventoryTypes
    }
  };

  return (
    <div className={cssClasses.pageWrapper}>
      <Box className={cssClasses.wrapperHeader}>
        <div className={cssClasses.headerTittle}>
          {type === 'Event' ? '' : projectTitle}
        </div>
        {/* {type === "Event" && (
          <div
            style={{
              width: window.innerWidth <= 820 ? "60%" : "30%",
            }}
          >
            <div className={cssClasses.blockLabel}>Select Launch</div>
            <DropDown
              list={allLaunches}
              selectedValue={selectedLaunch}
              onChangeSelect={(_value) => {
                setSelectedLaunch(_value);
                sessionStorage.setItem(
                  "liveInventoryLaunchId",
                  JSON.stringify(_value)
                );
                let launches=allLaunches.filter(({launchId})=>launchId===_value);
                sessionStorage.setItem(
                  "liveInventoryProjectId",
                  JSON.stringify(launches[0].projectId.projectId)
                );
                getAllInventory(_value, unitTypeDisplay, unitStatusDisplay);
              }}
              helperText=""
              style={{
                background: "#F2F4F7",
                color: "rgb(102, 112, 133)",
              }}
              placeHolder="Select Launch"
            ></DropDown>
          </div>
        )} */}
        {/* <div>
          <CalendarTodayIcon />
          <Typography>08/12/2022</Typography>
        </div>
        <div>
          <AccessTimeIcon />
          <Typography>12:00 AM</Typography>
        </div> */}
      </Box>
      {showInventory && (
        <Box className={cssClasses.wingCardsContainer}>
          {sortBy(wingWiseGroups, 'wingName').map((WingItem, WingIndex) => (
            <Box
              className={
                wingId !== ' All'
                  ? cssClasses.wingCardContainer
                  : cssClasses.wingCardContainer2
              }
              key={`WingItem_${WingIndex + 1}`}
            >
              <div className={cssClasses.wingHeader}>
                <p className={cssClasses.wingCardHeading}>
                  {/* {WingItem.Units[0].wingName.includes("WING") ||
                WingItem.Units[0].wingName
                  .toLowerCase()
                  .includes("building") ? (
                  ""
                ) : ( */}
                  {/* <span> WING </span> */}
                  {/* )}{" "} */}

                  {WingItem.displayName ? WingItem.displayName : WingItem.wingName}
                </p>
                <Box className={cssClasses.wingBhkWrapper}>
                  {sortBy(
                    uniqBy(WingItem.Units, 'inventoryType'),
                    'inventoryType'
                  ).map((bhkItem, bhkIndex) =>
                  (
                    <div
                      className={cssClasses.bhkBox}
                      key={`${bhkItem}_${bhkIndex}`}
                      style={{
                        backgroundColor:
                          unitTypeColorArr[bhkItem.inventoryType]?.color !== ''
                            ? unitTypeColorArr[bhkItem.inventoryType]?.color
                            : '#FFFFFF',
                        color:
                          unitTypeColorArr[bhkItem.inventoryType]?.textColor !==
                            ''
                            ? unitTypeColorArr[bhkItem.inventoryType]?.textColor
                            : '#000',
                        // background: bhkItem?.color !== "" ? bhkItem?.color : "#FFFFFF",
                        // color: bhkItem?.textColor !== "" ? bhkItem?.textColor : "#000",
                      }}
                    >
                      {bhkItem.unitId.displayUnitType ? bhkItem.unitId.displayUnitType : bhkItem.inventoryType}
                    </div>
                  )
                  )}
                  {/* {sortBy(
                  uniqBy(WingItem.Units, "inventoryStatus"),
                  "inventoryStatus"
                ).map((bhkItem, bhkIndex) => (
                  <div
                    className={cssClasses.bhkBox}
                    key={`${bhkItem}_${bhkIndex}`}
                    style={{ background: bhkItem?.colorAccordingToStatus }}
                  >
                    {bhkItem.inventoryStatus}
                  </div>
                ))} */}
                </Box>
              </div>
              <div className={cssClasses.flatTable}>
                <div
                  className={`${cssClasses.flatTableHeader} ${cssClasses.floorRow}`}
                >
                  <div>Floor</div>
                  <div>Unit Number</div>
                </div>
                <div className={cssClasses.floorRow}><div>Unit Type</div>{inventoryTypeWise && inventoryTypeWise.find((wing) => wing.wingName === WingItem.wingName)["type"].map((type, i) => (
                  <div style={{ textOverflow: "ellipsis", overflow: "hidden", fontSize: "1.6rem", border: "none" }}>
                    {type.inventoryType}
                  </div>
                ))}</div>
                {sortBy(WingItem.Units.floorWise, (fl) => {
                  return isNaN(parseInt(fl.Floor.split(' ')[1]))
                    ? 0
                    : parseInt(fl.Floor.split(' ')[1]);
                })
                  .reverse()
                  .map((floorRowItem, floorRowIndex) => (
                    <div
                      className={cssClasses.floorRow}
                      key={`floorRowItem_${floorRowIndex + 1}`}
                    >
                      {sortBy(floorRowItem.Units, floorRowItem?.Floor.includes("GROUND") ? unit => parseInt(unit.unitNo) : 'unitNo').map(
                        (floorCellItem, floorCellIndex) => (
                          <>
                            {floorCellIndex === 0 && (
                              <div>
                                {floorRowItem?.Floor.replace("FLOOR", "")}
                              </div>
                            )}
                            <div
                              style={{
                                // background:
                                //   floorCellItem.colorAccordingToInventoryType
                                //     ? // ? floorCellItem.colorAccordingToStatus
                                //       //   ? floorCellItem.colorAccordingToStatus
                                //       floorCellItem.colorAccordingToInventoryType
                                //     : "#FFFFFF",
                                background:
                                  floorCellItem?.color !== ''
                                    ? floorCellItem?.color
                                    : '#FFFFFF',
                                color: floorCellItem?.unitId?.unitNo ?
                                  floorCellItem?.textColor !== ''
                                    ? floorCellItem?.textColor
                                    : '#000' : "transparent",
                              }}
                              key={`floorCellItem${floorCellIndex + 1}`}
                            >
                              {floorCellItem?.unitId?.unitNo ? floorCellItem?.unitId?.unitNo : "unit"}
                            </div>
                          </>
                        )
                      )}
                    </div>
                  ))}
              </div>
            </Box>
          ))}
        </Box>
      )}

      {showInventory === false && (
        <Box width={"100%"} height={"100%"}>
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={EmptyListIcon} alt='No Inventory' />
            </div>
            <div className={cssClasses.emptyTitle}>
              Live Inventory not configured in event settings
            </div>
          </div>
        </Box>

      )}
    </div>
  );
}

export default LiveInventory;